import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-12 col-xxxl-12" }
const _hoisted_3 = { class: "col-xxl-6 col-xxxl-6" }
const _hoisted_4 = { class: "col-xxl-6 col-xxxl-6" }
const _hoisted_5 = { class: "col-xxl-12 col-xxxl-12" }

import WeeklySales from "../../components/Dashboard/Ecommerce/WeeklySales.vue";
import WebsiteVisitors from "../../components/Dashboard/Ecommerce/WebsiteVisitors.vue";
import ClientPaymentStatus from "../../components/Dashboard/CRMSystem/ClientPaymentStatus.vue";
import NaviresPecheSansLicence from "../../components/Dashboard/Ecommerce/NaviresPecheSansLicence.vue";

// All components use defineComponent for proper TypeScript support

export default /*@__PURE__*/_defineComponent({
  __name: 'AnalyticPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NaviresPecheSansLicence)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ClientPaymentStatus)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(WebsiteVisitors)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(WeeklySales)
    ])
  ]))
}
}

})